<template>
  <div>
    <v-form :model="valid" ref="formReport" lazy-validation>
      <v-card>
        <v-card-title>
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="d-flex" cols="12" md="3" sm="6" style="padding-bottom: 0">
              <v-autocomplete
                outlined
                dense
                v-model="params.member_id"
                :items="clientListByLocationOptRep"
                auto-select-first
                item-text="name"
                item-value="id"
                :label="$t('member') + '*'"
                :placeholder="$t('all')"
                clearable
                :rules="requireRules"
                required
                :search-input.sync="searchClient"
              >
                <template v-slot:selection="{ item }">{{ item.name }} ({{ $t(item.user_type) }})</template>
                <template v-slot:item="{ item }">{{ item.name }} ({{ $t(item.user_type) }})</template>
              </v-autocomplete>
            </v-col>

            <v-col class="d-flex" cols="12" md="3" sm="6" style="padding-bottom: 0">
              <v-autocomplete
                outlined
                dense
                v-model="params.category_id"
                :items="categoryListOptRep"
                auto-select-first
                item-text="name"
                item-value="id"
                :label="$t('category')"
                :placeholder="$t('all')"
                clearable
                required
              >
                <template v-slot:selection="{ item }">{{ item.name }}</template>
                <template v-slot:item="{ item }">{{ item.name }}</template>
              </v-autocomplete>
            </v-col>

            <v-col class="d-flex" cols="12" md="3" sm="6" style="padding-bottom: 0">
              <v-autocomplete
                outlined
                dense
                v-model="params.product_id"
                :items="listProductByCategory"
                auto-select-first
                item-text="name"
                item-value="id"
                :label="$t('product')"
                :placeholder="$t('all')"
                clearable
                required
              >
                <template v-slot:selection="{ item }">{{ item.name }}</template>
                <template v-slot:item="{ item }">{{ item.name }}</template>
              </v-autocomplete>
            </v-col>

            <v-col class="d-flex" cols="12" md="3" sm="6" style="padding-bottom: 0">
              <v-btn
                class="mr-6" 
                dark color="blue-grey" 
                elevation="2" 
                outlined text 
                @click="handleRun('nowebview')"
                :loading="loadingReport"
                >
                <v-icon class="mr-1"> mdi-magnify </v-icon>
                <template v-slot:loadingReport>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>

              <v-btn @click="exportExcel('exportExcel')" outlined>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#000000"><path d="M24.08,6.88v158.24h104.22125l-5.85203,-6.88h-91.48922v-144.48h65.36v44.66625h44.72v41.33375h6.88v-46.09735l-0.88015,-0.88015c-0.12384,-0.15136 -0.26193,-0.28928 -0.40985,-0.41656l-45.49265,-45.48594zM103.2,18.57734l32.9689,33.02266h-32.9689zM58.97719,65.36l18.12047,30.96l-19.78,30.96h16.56844l10.77015,-19.98156c0.74992,-1.92984 1.23813,-3.40447 1.44453,-4.34703h0.1075c0.42656,2.01928 0.84393,3.38883 1.24297,4.13875l10.76344,20.19656h16.46766l-19.05438,-31.27578l18.53703,-30.65094h-15.53375l-9.83625,18.32875c-0.946,2.39424 -1.61772,4.28522 -1.9686,5.48922h-0.10078c-0.54352,-2.01928 -1.16949,-3.81894 -1.86781,-5.28094l-8.90235,-18.53703zM130.72,106.64v30.96h-17.2l29.22656,34.4l29.25344,-34.4h-17.2v-30.96zM137.6,113.52h10.32v30.96h8.94265l-14.11609,17.2l-14.08922,-17.2h8.94265z"></path></g></g></svg>
              </v-btn>
            </v-col>

          </v-row>
        </v-card-title>

        <v-card-text>
          <v-row type="flex" class="row-bg" justify="center">
            <v-col cols="6" md="6" sm="6">
              {{ $t('date') }} ៖ {{ params.date }}
            </v-col>

            <v-col cols="6" md="6" sm="6" style="text-align: right">
              <v-btn color="blue-grey" class="ma-2 white--text" @click="uploadFileModal = true">
                {{$t("attachFile")}}
                <v-icon right dark>mdi-cloud-upload</v-icon>
                <span style="margin-left: 10px;" v-if="countImage"> ({{ countImage }})</span>
              </v-btn>

            </v-col>

            <v-col cols="12" style="overflow-x: auto;display: block;white-space: nowrap;">
              <table class="report" style="width: 100%" id="exportExcel">
                <thead>
                <tr>
                  <th>{{ $t("n0") }}</th>
                  <th>{{ $t("item") }}</th>
                  <th>{{ $t("qty") }}</th>
                  <th style="text-align: center">{{ $t("actualQuantity") }}</th>
                  <th style="text-align: center">{{ $t("balance") }}</th>
                  <th>{{ $t("note") }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(doc,j) in dataList" :key="j">
                  <td style="text-align: center">{{ j + 1 }}</td>
                  <td>{{ doc.sku }} : {{ doc.product_name }}</td>
                  <td style="text-align: center; width: 150px">{{ doc.base_qty | formatNumber }} {{ doc.unit_name }}</td>
                  <td style="text-align: center; width: 150px">
                    <v-text-field
                        type="number"
                        v-model="doc.qty_on_hand"
                        hide-details="auto"
                        min="0"
                        dense
                        @change.native="updateStockDetail(doc,j)"
                        @keyup.native="updateStockDetail(doc,j)"
                    >
                    </v-text-field>
                  </td>

                  <td style="width: 150px; text-align: center"><span :style="doc.balance != '' ? (doc.balance < 0 ? ('color: red') : ('color:green')) : ''">{{ doc.balance }}</span></td>

                  <td>
                    <v-text-field
                        v-model="doc.note"
                        hide-details="auto"
                        dense
                        @change.native="updateStockDetail(doc,j)"
                        @keyup.native="updateStockDetail(doc,j)"
                    >
                    </v-text-field>

                  </td>
                </tr>
                </tbody>

              </table>

              <v-row>
                <v-spacer></v-spacer>
                <v-btn
                    rounded
                    @click="checkConfirmation($event)"
                    style="min-width: 150px; margin: 10px;"
                    color="success"
                    :loading="loadingSubmit"
                >
                  <font-awesome-icon style="margin-right: 10px" icon="check-circle"/>
                  <span>{{ $t('update') }}</span>
                  <template v-slot:loadingSubmit>
                    <span class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </template>
                </v-btn>
              </v-row>
            </v-col>

          </v-row>
        </v-card-text>

      </v-card>
    </v-form>

    <!-- confirmation -->
    <v-dialog v-model="confirmationModal" persistent width="50%">
      <v-overlay :value="overlayConfirmation">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card>
          <v-card-title>
              <v-spacer></v-spacer>
              <v-btn
                  fab
                  text
                  icon
                  @click="handleClose"
                  valid="false"
                  v-shortkey="['esc']"
                  @shortkey.native="handleClose"
              >
                  <v-icon dark>mdi-close</v-icon>
              </v-btn>
          </v-card-title>

          <v-card-text class="text-center">
              <img src="data:image/png;base64,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" alt="">
              <h1 class="mt-3 mb-2">{{ $t('confirmationReconcile') }}</h1>

              <v-data-table
                :headers="headers"
                :items="confirmationList"
                hide-default-footer
                class="elevation-1 mt-10"
                :mobile-breakpoint="0"
                >
                  <!-- Header -->
                  <template v-slot:header.product_name="{ header }">{{ $t(header.text) }}</template>
                  <template v-slot:header.qty="{ header }">{{ $t(header.text) }}</template>
                  <template v-slot:header.price="{ header }">{{ $t(header.text) }}</template>
                  <template v-slot:header.amount="{ header }">{{ $t(header.text) }}</template>
                  <!-- Body section -->
                  <template v-slot:item.product_name="{ item }">{{ item.product_name }}</template>
                  <template v-slot:item.qty="{ item }">{{ item.qty }}</template>
                  <template v-slot:item.price="{ item }">{{ parseFloat(item.price) | formatNumber }}{{ getCurrencySymbol(item.currency_code) }}</template>
                  <template v-slot:item.amount="{ item }">{{ parseFloat(item.amount) | formatNumber }} {{ getCurrencySymbol(item.currency_code) }}</template>
              </v-data-table>

              <p class="mt-8">{{ $t('paymentAmountForMissingProduct') }}</p>
              <h2>{{ parseFloat(totalAmountConfirmation) | formatNumber}}{{ getCurrencySymbol(currency_code) }}</h2>

          </v-card-text>

          <v-card-actions class="pa-10">
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" @click="handleUpdateStock()" :loading="loadingConfirmSubmit">{{$t("yes")}}</v-btn>

            <v-btn rounded @click="handleClose">{{$t("close")}}</v-btn>
          </v-card-actions>
      </v-card>

    </v-dialog>

    <!-- upload -->
      <v-dialog v-model="uploadFileModal" persistent max-width="600px">
        <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>

        <v-card>
          <v-card-title class="dialog-header">
            <span class="headline">{{ $t("attachFile") }}</span>
            <v-spacer></v-spacer>
            <v-btn
              fab
              text
              icon
              @click="uploadFileModal = false"
              valid="false"
              v-shortkey="['esc']"
              @shortkey.native="uploadFileModal = false"
            >
            <span class="white--text">
              <v-icon dark>
                mdi-close
              </v-icon>
            </span>
            </v-btn>
          
            </v-card-title>
              <v-card-text>

                <v-form>
                  <v-container>
                    <fieldset class="multiple-upload">
                      <span style="float:left" class="avatar-container" v-for="(pre, index) in previewImage" :key="index">
                        <img
                          v-show="['image/gif', 'image/png', 'image/jpg', 'image/jpeg'].includes(pre.type)"
                          :ref="'image'"
                          aspect-ratio="1"
                          class="grey lighten-2 multiple-preview"
                        >
                        <div v-if="['image/gif', 'image/png', 'image/jpg', 'image/jpeg'].includes(pre.type) == false" class="title-file">{{ pre.name }}</div>
                        
                        <button type="button" class="remove-avatar" style="top: 2px; right: 8px" @click="removeFileUpload(index)">x</button>
                      </span>
                      <div style="clear:both"></div>
                    </fieldset>

                    <label id="avatar" style="width: 130px">{{ $t("browFile") }}
                      <input type="file" size="60"
                        multiple
                        @change="upload"
                        >     
                    </label>

                    <v-divider style="margin-top: 10px;"></v-divider>

                    <div style="text-align:right">
                      <v-btn class="v-btn v-btn--contained theme--light v-size--default error white--text" text @click="handleUpload(false)">
                        {{ $t('clear') }}
                      </v-btn>

                      <v-btn @click="handleUpload(true)" class="ma-2 v-btn v-btn--contained theme--light v-size--default success white--text" text>
                        <font-awesome-icon icon="check-circle" class="mr-1"/>
                        {{ $t('ok') }}
                      </v-btn>
                    </div>

                  </v-container>
                </v-form>

              </v-card-text>
        </v-card>
      </v-dialog>
  </div>

</template>

<script>
import ValidatorMixin from "../../../mixins/validatorMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import ReportDataMixin from "../../../mixins/reportDataMixin";
import moment from "moment";
import {provider} from "../../../service/provider"
import axios from "axios";

export default {
  components: {},
  mixins: [ValidatorMixin, OptionDataMixin, ReportDataMixin],
  data() {
    return {
      valid: false,
      loadingReport: false,
      loadingSubmit: false,
      loadingConfirmSubmit: false,
      overlayConfirmation: false,
      confirmationModal: false,
      uploadFileModal: false,
      searchClient: "",
      previewImage  : [],
      countImage: 0,

      confirmationList: [],
      totalAmountConfirmation: 0,
      currency_code: '',

      transaction_reconcile: [],
      transaction_reconcile_missing: [],

      params: {
        id: "",
        member_id: this.$store.state.userDoc.contact_id,
        category_id: "",
        product_id: "",
        note: " ",
        date: moment().format("YYYY/MM/DD"),
        eco_business: "in_side",
        offset: 0,
        limit: 10000
      },

      headers: [
        {text: "productName", value: "product_name"},
        {text: "qty", value: "qty", align: "end"},
        {text: "price", value: "price",  align: "end"},
        {text: "amount", value: "amount" , align: "end"},
      ],

      dataList: [],
      memberName: "",
      token: ""
    }
  },
  methods: {
    handlePrint(event) {
      event.preventDefault();
      window.print();
    },

    checkConfirmation(){
      this.transaction_reconcile = [];
      this.transaction_reconcile_missing = [];
      this.dataList.map((o) => {
        if (o.qty_on_hand !== "") {
          this.transaction_reconcile.push(o);

          if(o.balance < 0){
            this.transaction_reconcile_missing.push(o); 
          }
        }
      });

      this.$nextTick(() => {
        if(this.transaction_reconcile_missing.length){
          this.confirmationModal = true;
          this.overlayConfirmation = true;

          let product_list = this.transaction_reconcile_missing.map((arr) => {
            return { 
              product_id: arr.id, 
              variation_id: arr.variation_id,
              qty: arr.balance * (-1) 
            };
          });

          let param = {
            client_id: this.params.member_id,
            currency_code: this.transaction_reconcile_missing[0].currency_code,
            product_list: product_list,
          }

          let url = provider.baseURL + provider.getListProductConfirm;

          axios.post(url, param, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                this.confirmationList        = res.data.data.products_detail;
                this.totalAmountConfirmation = res.data.data.total_amount;
                this.currency_code           = res.data.data.products_detail[0].currency_code;
                this.overlayConfirmation     = false;
              }
            },
            error => {
              console.log(error)
            }
        );

        }else{
          this.handleUpdateStock();
        }
      });
    },

    handleUpdateStock() {
        let vm = this;
        let newData = {
          id            : "",
          client_id     : vm.params.member_id,
          date          : vm.params.date,
          note          : vm.params.note,
          eco_business  : "in_side",
          transaction_reconcile_line: this.transaction_reconcile
        };

          if (vm.transaction_reconcile.length) {

            if(! vm.transaction_reconcile_missing.length){
               vm.loadingSubmit = true;
            }else{
              vm.loadingConfirmSubmit = true;
            }

            let url = provider.baseURL + provider.storeStockReconcileV2;
            axios.post(url, newData, {headers: {Authorization: localStorage.token}}).then(
                res => {
                  if (res.data.response && res.data.response.code === 200) {

                    this.storeAttachFile(res.data.data.transaction_reconcile_id);

                    vm.loadingSubmit                  = false;
                    vm.loadingConfirmSubmit           = false;
                    vm.confirmationModal              = false;
                    vm.dataList                       = [];
                    vm.transaction_reconcile          = [];
                    vm.transaction_reconcile_missing  = [];
                    this.handleRun('nowebview');
                    vm.$notify({
                      title: "Success",
                      message: vm.$t("success"),
                      type: "success",
                      duration: 1500
                    });

                  } else {
                    vm.loadingSubmit = false;
                  }
                },
                error => {
                  console.log(error)
                }
            );
          } else {
            vm.$notify({
              title: "Warning",
              message: vm.$t("emptyDataToUpdate"),
              type: "warning",
              duration: 700
            });
            vm.loadingSubmit = false;
          }

    },

    storeAttachFile(transaction_reconcile_id){
      let vm = this;
      if (vm.previewImage.length) {
        vm.overlay  = true;

        let formData= new FormData();
        formData.append("transaction_reconcile_id", transaction_reconcile_id);
        for( var i = 0; i < this.previewImage.length; i++ ){
          let file = this.previewImage[i];
          formData.append('attachment[' + i + ']', file);
        }

        let url = provider.baseURL + provider.uploadDocumentReconcile;

        axios.post(url, formData, {headers: {
          Authorization: localStorage.token,
          "Content-Type": "multipart/form-data"
          }}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                this.previewImage = [];
                this.countImage   = 0;
              }
            },
            error => {
              console.log(error)
            }
        );
      }
    },

    updateStockDetail(doc, j) {
      if(doc.qty_on_hand != ''){
        doc.balance = +doc.qty_on_hand - +doc.base_qty;
      }else{
        doc.balance = '';
      }

      this.dataList[j] = doc;
    },

    handleRun(token) {
      let vm = this;
      if (vm.$refs.formReport.validate()) {
        vm.loadingReport = true;
        let url = provider.baseURL + provider.getListStockClientById;
        return new Promise((resolve, reject) => {
          axios.post(url, vm.params, {headers: {Authorization: token === "nowebview" ? localStorage.token : token}}).then(
              res => {
                if (res.data.response && res.data.response.code === 200) {
                  resolve(res.data.data);
                  vm.loadingReport = false;
                  res.data.data.map((d) => {
                    d.product_id = d.id;
                    d.transaction_reconcile_line_id = "";
                    d.transaction_reconcile_id = "";
                    d.transaction_line_id = "";
                    d.base_qty = d.qty;
                    d.status = "";
                    d.qty_on_hand = "";
                    d.balance = "";
                    d.note = "";
                    return d;
                  })
                  vm.dataList = res.data.data;
                } else {
                  vm.loadingReport = false;
                }
              },
              error => {
                reject(error);
              }
          );
        });

      }
    },

    handleClose(){
      this.confirmationModal = false;
    },

    upload(event) {    
      /** * splite extension to check validation */
      let selectedFiles  = event.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        this.previewImage.push(selectedFiles[i]);
      }

      this.renderImage();
      event.target.value = '';
    },

      removeFileUpload(index){
        this.previewImage.splice(index, 1);
        this.renderImage();
      },

      renderImage() {
        let vm = this;
        for (let i = 0; i < vm.previewImage.length; i++) {
          let reader = new FileReader();
          
          if(['image/gif', 'image/png', 'image/jpg', 'image/jpeg'].includes(vm.previewImage[i].type)){
            reader.onload = () => {
              vm.$refs.image[i].src = reader.result;
            };
          }
          reader.readAsDataURL(vm.previewImage[i]);
        }
      },

      handleUpload(bool){
        if(bool){
          if(this.previewImage.length){
            this.countImage = this.previewImage.length;
            this.uploadFileModal = false;
          }else{
            this.$notify({
              title: "Error",
              message: this.$t("pleaseBroweImage"),
              type: "error",
              duration: 1200
            });
          }
       }else{
          this.previewImage = [];
          this.countImage   = 0;
          this.uploadFileModal = false;
        }
      }
  },
  watch: {
    "params.category_id"(val){
      this.params.product_id = "";
      this.fetchProductByCategory(val);
    }, 
  },
  computed: {},
  created() {
    let vm = this;
    vm.fetchCategoryOptionRep();
    vm.fetchContactByLocationOptionRep();
  }
}
</script>

<style scoped>
 #avatar{
      text-align: center;
      width: 100%;
      padding: 10px;
      background: gray; 
      display: table;
      color: #fff;
      cursor: pointer;
      margin:0;
      margin-top:10px;
  }
  input[type="file"] {
      display: none;
  }

  .avatar-container {
      position: relative;
  }

  .avatar-container .remove-avatar {
      position: absolute;
      top: 5px;
      right: 5px;
      color: #ffffff;
      background-color: #b3b3b3;
      border-radius: 50%;
      width: 24px;
      height: 25px;
      line-height: 1.5;
  }

  .v-btn--floating .v-btn__content {
      height: auto !important;
  }

  .dimention {
      justify-content: center; 
      display: flex;
  }

  .multiple-upload {
      min-height: 115px;
      border: 1.5px solid gray;
      border-style: dotted;
      padding-left: 5px;
      font-size: 16px;
  }

  .title-file {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    line-height: 5;
  }

  .multiple-preview, .title-file {
    width: 100px; 
      height: 80px;
      margin-right: 5px; 
      margin-bottom: 5px;
      border: 1px solid gray;
  }
  
</style>